/**
 * Session client. The cookie is shared with the back office — both apps live
 * on the same origin, so signing in on either signs you in on both.
 */

export interface AuthUser {
  id: number
  email: string
  name: string
  role: 'admin' | 'user'
}

export class AuthError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message)
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(path, {
    method,
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw new AuthError(res.status, (data as { error?: string }).error ?? `request failed (${res.status})`)
  }
  return data as T
}

export const auth = {
  login: (email: string, password: string) => request<AuthUser>('POST', '/api/auth/login', { email, password }),
  logout: () => request<{ ok: boolean }>('POST', '/api/auth/logout'),
  me: () => request<AuthUser>('GET', '/api/auth/me'),
}
